import { useGraphQLClient } from "@package/graphql/react";
import { useQuery } from "@tanstack/react-query";
import { createContext, useContext } from "react";

import { ProductConfigQueryCache } from ".";
import { useUserId } from "../../context/auth/hooks";

const CacheContext = createContext<ProductConfigQueryCache>(new ProductConfigQueryCache());
export const useProductConfigsCache = () => useContext(CacheContext);

export const CachedDataPreLoader = ({
  children,
  loadingComponent,
}: {
  children: React.ReactNode;
  loadingComponent?: React.ReactNode;
}) => {
  const cache = useProductConfigsCache();
  const graphql = useGraphQLClient();
  const userId = useUserId();
  const valid = useQuery({
    queryKey: ["cached", "product-meta"],
    queryFn: async () => {
      await cache.load(graphql, userId);

      // Wait to be sure data is available in indexdb
      // Sometimes it seems the transactions are not fully committed after writing
      // Obviously this is a hack so feel free to remove if you have a better idea
      await new Promise((resolve) => setTimeout(resolve, 500));

      return true;
    },
  });

  if (valid.isLoading) return loadingComponent ?? null;
  return <>{children}</>;
};
